export default "__VITE_ASSET__c54682aa__"